import React, { useState } from "react";
import "./productDetail.css";

// Import product images
import s24_1 from "../../assets/images/s24/s24_1.webp";
import s24_2 from "../../assets/images/s24/s24_2.webp";
import s24_3 from "../../assets/images/s24/s24_3.webp";
import s24_4 from "../../assets/images/s24/s24_4.webp";

const ProductDetail = () => {

    const product = {
        id: 1,
        name: "Samsung Galaxy S24 Ultra - Refurbished",
        brand: "Samsung",
        condition: "Good",
        storageOptions: ["8 GB / 256 GB", "12 GB / 512 GB"],
        price: 80000,
        originalPrice: 129999,
        discount: 52,
        colors: ["Black", "White", "Titanium Gray", "Violet"],
        rating: 4.8,
        reviews: 97,
        warranty: "6 Months Warranty",
        refundDays: 15,
        qualityCheck: 32,
        images: [s24_1, s24_2, s24_3, s24_4],
    };

    const [mainImage, setMainImage] = useState(product.images[0]);
    const [selectedStorage, setSelectedStorage] = useState(product.storageOptions[0]);
    const [selectedCondition, setSelectedCondition] = useState("Good");
    const [selectedColor, setSelectedColor] = useState(product.colors[0]);

    return (
        <div className="container py-4 product-detail-page">
            <div className="row g-4">
                {/* ===== Left Image Section ===== */}
                <div className="col-lg-6">
                    <div className="d-flex flex-column align-items-center">
                        <div className="main-img-wrapper mb-3">
                            <img
                                src={mainImage}
                                alt={product.name}
                                className="main-product-img"
                            />
                        </div>

                        <div className="d-flex gap-2 flex-wrap justify-content-center">
                            {product.images.map((img, i) => (
                                <img
                                    key={i}
                                    src={img}
                                    alt={`thumb-${i}`}
                                    className={`thumb-img ${mainImage === img ? "active" : ""}`}
                                    onClick={() => setMainImage(img)}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="mt-3 d-flex justify-content-around stats-box p-2 rounded-3">
                        <div><b>{product.qualityCheck}</b><br />Point Quality Check</div>
                        <div><b>{product.refundDays}</b><br />Days Refund</div>
                        <div><b>{product.warranty.split(" ")[0]}</b><br />Months Warranty</div>
                    </div>
                </div>

                {/* ===== Right Content Section ===== */}
                <div className="col-lg-6">
                    <h4 className="fw-bold text-dark mb-1">{product.name}</h4>
                    <p className="text-muted small mb-2">
                        {product.brand} Warranty, {product.condition}, {product.storageOptions[0]}, {product.color}
                    </p>

                    <div className="d-flex align-items-center mb-2">
                        <span className="badge bg-success me-2">
                            <i className="bi bi-check-circle-fill me-1"></i>
                            Verified Quality
                        </span>
                        <small className="text-muted">Checked by Experts</small>
                    </div>

                    <h3 className="fw-bold text-dark">
                        ₹{product.price.toLocaleString()}{" "}
                        <small className="text-muted text-decoration-line-through fs-6">
                            ₹{product.originalPrice.toLocaleString()}
                        </small>{" "}
                        <span className="text-danger fs-6">-{product.discount}%</span>
                    </h3>

                    <p className="text-muted small mb-3">
                        For detailed specifications,{" "}
                        <a
                            href="https://www.gsmarena.com/samsung_galaxy_s24_ultra-12771.php"
                            className="text-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            click here
                        </a>.
                    </p>

                    <div className="d-flex gap-3 mb-4">
                        <button className="btn btn-dark w-30">Enquire Now</button>
                    </div>

                    <h6 className="fw-semibold mb-1">Condition</h6>
                    <div className="d-flex gap-2 mb-3">
                        {["Fair", "Good", "Superb"].map((c) => (
                            <button
                                key={c}
                                className={`btn btn-sm rounded-pill ${selectedCondition === c ? "btn-dark" : "btn-outline-secondary"}`}
                                onClick={() => setSelectedCondition(c)}
                            >
                                {c}
                            </button>
                        ))}
                    </div>

                    <h6 className="fw-semibold mb-1">Storage</h6>
                    <div className="d-flex gap-2 flex-wrap mb-3">
                        {product.storageOptions.map((s) => (
                            <button
                                key={s}
                                className={`btn btn-sm rounded-pill ${selectedStorage === s ? "btn-dark" : "btn-outline-secondary"}`}
                                onClick={() => setSelectedStorage(s)}
                            >
                                {s}
                            </button>
                        ))}
                    </div>

                    <h6 className="fw-semibold mb-1">Color</h6>
                    <div className="d-flex gap-2 mb-3">
                        {product.colors.map((color) => (
                            <div
                                key={color}
                                onClick={() => setSelectedColor(color)}
                                className={`color-circle ${selectedColor === color ? "active" : ""}`}
                                style={{ backgroundColor: color.toLowerCase().replace(" ", "") }}
                            ></div>
                        ))}
                    </div>


                </div>
            </div>
        </div>
    );
};

export default ProductDetail;
